import store from 'store2';
import { api } from '../actions';

const initialState = {
    user: null,
    markers: [],
    token: store.get('accessToken'),
};

export default (state = initialState, action) => {
    switch (action.type) {
        case api.users.me.success.type:
        case api.users.updateMyAccount.success.type:
            return { ...state, user: action.result };
        case api.auth.login.success.type:
        case api.auth.getToken.success.type:
        case api.users.create.success.type:
        case api.users.join.success.type:
            return { ...state, ...action.result };
        case api.listenUserUpdated.type:
            if (action.user._id !== state.user._id) {
                return state;
            }

            return {
                ...state,
                markers: action.marker ? [...state.markers, action.marker] : state.markers,
                user: { ...state.user, ...action.user },
            };

        default:
            return state;
    }
};
